import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import '@shui/core/sh-spinner';

// Enable production mode if needed
if (environment.production) {
    enableProdMode();
}

// Bootstrap the Angular application
bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection({ eventCoalescing: true }), ...appConfig.providers]
}).catch((err) => console.error(err));
